module.exports = global["Globalize"] = require("-!./globalize.min.js");


//////////////////
// WEBPACK FOOTER
// ./lib/globalize/globalize.min.js-exposed
// module id = 23
// module chunks = 88 89